import { Cache } from '.';

export class LocalStorageCache<K extends string, V> implements Cache<V> {
  private key: K;
  private defaultValue: V;

  constructor(key: K, defaultValue: V) {
    this.key = key;
    this.defaultValue = defaultValue;
  }

  get() {
    if (typeof window !== 'undefined') {
      const raw = window.localStorage.getItem(this.key);
      const payload: V = JSON.parse(raw!);
      return payload ?? this.defaultValue;
    }
    return this.defaultValue;
  }

  set(value: V) {
    const payload = JSON.stringify(value);
    window.localStorage.setItem(this.key, payload);
  }

  delete() {
    window.localStorage.removeItem(this.key);
  }
}
